import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import PrimaryButton from "shared/components/PrimaryButton";
import {
  COLOR_BORDER,
  COLOR_GREY_8,
  COLOR_PRIMARY_BACKGROUND,
  COLOR_PRIMARY_MAIN,
  COLOR_WHITE,
} from "shared/theme/colors";
import { border, flex } from "shared/theme/mixins";

export const StyledWrapper = styled(Box)`
  ${flex({ fd: "column" })};
`;

export const StyledContainer = styled(Box)`
  ${flex({ fd: "column" })};
  ${border(1, COLOR_BORDER)};
  border-radius: 1rem;
  background-color: ${COLOR_WHITE};
  padding: 10px 16px 16px;
  min-height: 232px;
`;

export const StyledToolbarContainer = styled(Box)`
  ${flex({ ai: "center" })};
  column-gap: 4px;
  background-color: ${COLOR_WHITE};
  margin-bottom: 1rem;
`;

export const StyledEditorContainer = styled(Box)`
  min-height: 182px;
  font-size: 14px;

  figure {
    margin: 1em 0;
  }

  .draft-editor-image {
    border-radius: 1rem;
  }

  .public-DraftEditor-content {
    min-height: 182px;
    img {
      max-width: 100%;
      height: auto;
      display: block;
    }
  }

  .public-DraftEditorPlaceholder-root {
    color: ${COLOR_GREY_8};
    font-size: 14px;
  }
`;

export const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (props) => props !== "isHighlighted",
})<{ isHighlighted?: boolean }>`
  align-self: center;
  padding: 0;
  border-radius: 0.5rem;
  background-color: ${({ isHighlighted }) =>
    isHighlighted ? COLOR_PRIMARY_BACKGROUND : ""};

  svg {
    path {
      fill: ${({ isHighlighted }) =>
        isHighlighted ? COLOR_PRIMARY_MAIN : COLOR_GREY_8};
    }
  }
`;

export const StyledButton = styled(PrimaryButton)`
  width: 100%;
  margin-top: 1rem;
`;
